import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const popularParks = [
    { path: '/parc-asterix', label: 'Parc Astérix' },
    { path: '/', label: 'Disneyland Paris' },
    { path: '/europa-park', label: 'Europa-Park' },
    { path: '/efteling', label: 'Efteling' },
    { path: '/phantasialand', label: 'Phantasialand' },
    { path: '/portaventura', label: 'PortAventura' },
    { path: '/ferrari-land', label: 'Ferrari Land' },
    { path: '/futuroscope', label: 'Futuroscope' },
    { path: '/puydufou', label: 'Puy du Fou' },
    { path: '/magic-kingdom', label: 'Magic Kingdom' },
  ];

  return (
    <footer className="app-footer">
      <div className="footer-wrapper">
        <div className="footer-content">
          <nav className="footer-popular-parks" aria-label="Parcs populaires">
            {popularParks.map((park) => (
              <Link key={park.path} to={park.path} className="footer-link">
                {park.label}
              </Link>
            ))}
          </nav>
          <div className="footer-attributions">
            <div className="footer-weather-attribution">
              Weather data by <a href="https://open-meteo.com/" target="_blank" rel="noopener noreferrer" style={{color: '#7da7d9', textDecoration: 'none'}}>Open-Meteo.com</a>
            </div>
            <div className="footer-photos-attribution">
              Photos © <a href="https://sami-parks.fr" target="_blank" rel="noopener noreferrer" style={{color: '#7da7d9', textDecoration: 'none'}}>Sami Parks</a>
            </div>
            <div className="footer-lite-link">
              <a href="https://lite.magicparktimes.com" target="_blank" rel="noopener noreferrer" className="footer-link" title="Version optimisée pour connexions lentes">
                🚀 Version Lite
              </a>
            </div>
            <div className="footer-support-link">
              <Link to="/support-us" className="footer-link" title="Soutenez Magic Park Times">
                💝 Nous soutenir
              </Link>
            </div>
            <div className="footer-contact-link">
              <Link to="/contact" className="footer-link" title="Contactez-nous">
                Contact
              </Link>
            </div>
            <div className="footer-terms-link">
              <Link to="/conditions-utilisation" className="footer-link" title="Conditions d'utilisation et abonnements">
                CGU / CGV
              </Link>
            </div>
            <div className="footer-privacy-link">
              <Link to="/politique-confidentialite" className="footer-link" title="Politique de confidentialité">
                Confidentialité
              </Link>
            </div>
            <div className="footer-favorites">
              <span>Nos favoris:</span>
              <a href="https://parksmeets.com" target="_blank" rel="noopener noreferrer" className="footer-link">Parksmeet</a>
              <span>|</span>
              <a href="https://coasteractus.fr/" target="_blank" rel="noopener noreferrer" className="footer-link">Coasteractus</a>
              <span>|</span>
              <a href="https://www.dimensionparcs.fr/" target="_blank" rel="noopener noreferrer" className="footer-link">Dimension Parcs</a>
            </div>
          </div>
          <div className="footer-made-with">
            Built with 💖 by <a href="https://instagram.com/florent_kubrick" target="_blank" rel="noopener noreferrer" style={{color: '#7da7d9', textDecoration: 'none'}}>Florent Kubrick</a>
          </div>
          <span className="footer-copyright">
            © {new Date().getFullYear()} Magic Park Times
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 
